import { Button, DialogActions } from "@mui/material"
import { useDialog } from "../libs/dialog/DialogProvider"
import { ReactElement } from "react"

interface IConfirmProps {
    message:string
    children?:ReactElement|ReactElement[]|null
    yes?:string
    cancel?:string
    onConfirm:()=>void
}
export default function Confirm(props:IConfirmProps){
    const {closeDialog} = useDialog()
    const onYes = () => {
        closeDialog()
        props.onConfirm()
    }
    return <>
        <div className="content">
            <p>{props.message}</p>
            {props.children}
        </div>
        <DialogActions>
            <Button variant="contained" color="primary" onClick={onYes}>{props.yes || "YES"}</Button>
            <Button variant="contained" color="secondary" onClick={closeDialog}>{props.cancel || "CANCEL"}</Button>
        </DialogActions>
    </>
}